import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GlobalModule } from "@obg/ngx.global";

import { PostComponent } from "./post.component";

const DIRECTIVES: any[] = [PostComponent];

@NgModule({
	imports: [CommonModule, GlobalModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class PostModule {}
